import React, { useState } from 'react';
import SectionHeader from './SectionHeader';
import './Skills.css';

const skillsData = [
  {
    category: 'Product & Strategy',
    skills: [
      { name: 'Product Roadmap', context: 'Defined strategic roadmap for SAGAR & PARAS to align engineering with business goals.' },
      { name: 'User Research', context: 'Conducted 50+ user interviews to refine the SAGAR marine and oceanographic intelligence platform.' },
      { name: 'Go-to-Market Strategy', context: 'Led the launch strategy for CredTracker, helping students efficiently track and manage academic credits.' },
      { name: 'Data Analysis', context: 'Utilized Google Analytics & Mixpanel to optimize user funnel for client projects.' },
      { name: 'Agile Methodologies', context: 'Managed sprint cycles and backlog grooming for SIH 2024 winning team.' },
    ],
  },
  {
    category: 'Engineering',
    skills: [
      { name: 'React / Next.js', context: 'Built this portfolio, VITOPIA 2026, and multiple production-grade frontends.' },
      { name: 'JavaScript (ES6+)', context: 'Core language for all my web development projects including PARAS and SAGAR.' },
      { name: 'Node.js', context: 'Developed scalable backend microservices for CredTracker and PARAS.' },
      { name: 'Python / Django', context: 'Implemented AI/ML pipelines for parking detection in the PARAS system.' },
      { name: 'Three.js', context: 'Created immersive 3D experiences like the Vinyl Player and Hero scene.' },
    ],
  },
  {
    category: 'Data & AI',
    skills: [
      { name: 'Supabase', context: 'Used as the primary backend/auth for rapid prototyping in SAGAR.' },
      { name: 'SQL (PostgreSQL)', context: 'Designed complex schemas for academic credit tracking data in CredTracker.' },
      { name: 'AI/ML Integration', context: 'Integrated TensorFlow models for license plate recognition in PARAS.' },
      { name: 'RAG Systems', context: 'Built Retrieval Augmented Generation flows for context-aware chatbots in SAGAR.' },
      { name: 'Google Analytics', context: 'Tracked user engagement and behavior across multiple deployed apps.' },
    ],
  },
  {
    category: 'Tools',
    skills: [
      { name: 'Figma', context: 'Designed high-fidelity mockups and design systems for all web projects.' },
      { name: 'Jira', context: 'Used for task tracking and issue management in agile teams.' },
      { name: 'Git & GitHub', context: 'Version control for all projects; created the Open Source section you see above.' },
      { name: 'Mixpanel', context: 'Implemented advanced event tracking to measure product KPIs.' },
      { name: 'Docker', context: 'Utilized for Distributed Summary Synthesis research with SoSy-Lab.' },
    ],
  },
];

function Skills() {
  const [activeSkill, setActiveSkill] = useState(null);
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    setCursorPos({ x: e.clientX, y: e.clientY });
  };

  return (
    <>
      <SectionHeader index="04" label="Capabilities" title="Working range" />
      <p className="skills-hint mono-label">Hover any line for where it was used in anger.</p>
      <div className="skills-container" onMouseMove={handleMouseMove}>
        {skillsData.map((category, i) => (
          <div key={i} className="skill-category reveal">
            <h3>
              <span className="skill-category-index">{String.fromCharCode(65 + i)}.</span>
              {category.category}
            </h3>
            <ul>
              {category.skills.map((skill, j) => (
                <li
                  key={j}
                  onMouseEnter={() => setActiveSkill(skill)}
                  onMouseLeave={() => setActiveSkill(null)}
                >
                  {skill.name}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Floating Context Tooltip */}
      <div
        className={`skill-tooltip ${activeSkill ? 'visible' : ''}`}
        style={{
          top: cursorPos.y + 20 + 'px',
          left: cursorPos.x + 20 + 'px'
        }}
      >
        {activeSkill && (
          <>
            <div className="tooltip-title">{activeSkill.name}</div>
            <div className="tooltip-context">{activeSkill.context}</div>
          </>
        )}
      </div>
    </>
  );
}

export default Skills;